import styles from './QuickAddControls.module.css';

/**
 * The line under a disabled Lưu button that says why (AJ2). `role="status"` so a screen reader
 * hears it change as fields get filled; no `alert` because it is guidance, not an error.
 */
export function MissingHint({ message }: { message: string | null }) {
  if (message === null) return null;
  return (
    <p className={styles.missing} role="status">
      {message}
    </p>
  );
}
